var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"loading-overlay"},[_c('img',{key:_vm.gifKey,attrs:{"src":_vm.gifSrcWithTs,"alt":"Loading..."}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }